
export const styles = theme => ({
    icon: {
        fontSize: 40,
        float: 'right',
        cursor: 'pointer'
    },
    headerImage: {
        marginBottom: theme.spacing(3),
        position: 'relative'
    },
    containerImageRound: {
        width: '12rem',
        objectFit: "cover",
        border: "1px solid #ffffff",
        display: 'flex',
        boxShadow: 'unset',
        boxSizing: 'border-box',
        backgroundColor: '#f4f4f4',
    },
    boxAvatar: {
        position: 'absolute',
        bottom: 0,
    },
});